// Progressive enhancement: the real Add to cart button already works with
// no JS at all. This only forwards a click on the sticky duplicate to that
// real button, so it reuses its existing validation, loading state, and
// cart-drawer rendering instead of any of that being duplicated here.
class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.realButton = document.querySelector('.product-form__submit');
    this.button = this.querySelector('[data-sticky-add-to-cart-button]');

    if (!this.realButton) return;

    this.button.addEventListener('click', () => this.realButton.click());

    // Not intersecting covers both "scrolled past it" and "hasn't been
    // scrolled to yet" (e.g. a short viewport where it starts below the
    // fold) - either way, the real button isn't currently reachable, so
    // this stand-in should be showing.
    const observer = new IntersectionObserver(([entry]) => {
      this.toggleAttribute('data-visible', !entry.isIntersecting);
    });
    observer.observe(this.realButton);
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
